"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _BlobbyGrayIconImage = _interopRequireDefault(require("../../svg/BlobbyGrayIconImage"));
var _BlobbyGrayIconImport = _interopRequireDefault(require("../../svg/BlobbyGrayIconImport"));
var _BlobbyGrayIconUploadToTheCloud = _interopRequireDefault(require("../../svg/BlobbyGrayIconUploadToTheCloud"));
var _BlobbyIconCloudChecked = _interopRequireDefault(require("../../svg/BlobbyIconCloudChecked"));
var _BlobbyIconExportOrUploadPhoto = _interopRequireDefault(require("../../svg/BlobbyIconExportOrUploadPhoto"));
var _BlobbyIconFolder = _interopRequireDefault(require("../../svg/BlobbyIconFolder"));
var _BlobbyIconGraphReport = _interopRequireDefault(require("../../svg/BlobbyIconGraphReport"));
var _BlobbyIconHappy = _interopRequireDefault(require("../../svg/BlobbyIconHappy"));
var _BlobbyIconLeaf = _interopRequireDefault(require("../../svg/BlobbyIconLeaf"));
var _BlobbyIconLibrary = _interopRequireDefault(require("../../svg/BlobbyIconLibrary"));
var _BlobbyIconNursery = _interopRequireDefault(require("../../svg/BlobbyIconNursery"));
var _BlobbyIconParchment = _interopRequireDefault(require("../../svg/BlobbyIconParchment"));
var _BlobbyIconSeedBank = _interopRequireDefault(require("../../svg/BlobbyIconSeedBank"));
var _BlobbyIconSeedling = _interopRequireDefault(require("../../svg/BlobbyIconSeedling"));
var _BlobbyIconSeeds = _interopRequireDefault(require("../../svg/BlobbyIconSeeds"));
var _BlobbyIconSite = _interopRequireDefault(require("../../svg/BlobbyIconSite"));
var _BlobbyIconSparkles = _interopRequireDefault(require("../../svg/BlobbyIconSparkles"));
var _BlobbyIconWrench = _interopRequireDefault(require("../../svg/BlobbyIconWrench"));
var _Bug = _interopRequireDefault(require("../../svg/Bug"));
var _Calendar = _interopRequireDefault(require("../../svg/Calendar"));
var _IconCancel = _interopRequireDefault(require("../../svg/IconCancel"));
var _CaretDown = _interopRequireDefault(require("../../svg/CaretDown"));
var _CaretLeft = _interopRequireDefault(require("../../svg/CaretLeft"));
var _CaretRight = _interopRequireDefault(require("../../svg/CaretRight"));
var _CaretUp = _interopRequireDefault(require("../../svg/CaretUp"));
var _IconChargingBattery = _interopRequireDefault(require("../../svg/IconChargingBattery"));
var _IconCheckmark = _interopRequireDefault(require("../../svg/IconCheckmark"));
var _ChevronDown = _interopRequireDefault(require("../../svg/ChevronDown"));
var _ChevronUp = _interopRequireDefault(require("../../svg/ChevronUp"));
var _Close = _interopRequireDefault(require("../../svg/Close"));
var _Critical = _interopRequireDefault(require("../../svg/Critical"));
var _IconDashboard = _interopRequireDefault(require("../../svg/IconDashboard"));
var _Edit = _interopRequireDefault(require("../../svg/Edit"));
var _Error = _interopRequireDefault(require("../../svg/Error"));
var _Filter = _interopRequireDefault(require("../../svg/Filter"));
var _Folder = _interopRequireDefault(require("../../svg/Folder"));
var _IconFutures = _interopRequireDefault(require("../../svg/IconFutures"));
var _Help = _interopRequireDefault(require("../../svg/Help"));
var _Home = _interopRequireDefault(require("../../svg/Home"));
var _IconAdd = _interopRequireDefault(require("../../svg/IconAdd"));
var _IconArrowRight = _interopRequireDefault(require("../../svg/IconArrowRight"));
var _IconBusinessNetwork = _interopRequireDefault(require("../../svg/IconBusinessNetwork"));
var _IconCoinInHand = _interopRequireDefault(require("../../svg/IconCoinInHand"));
var _IconColumns = _interopRequireDefault(require("../../svg/IconColumns"));
var _IconComment = _interopRequireDefault(require("../../svg/IconComment"));
var _IconDataMigration = _interopRequireDefault(require("../../svg/IconDataMigration"));
var _IconEdit = _interopRequireDefault(require("../../svg/IconEdit"));
var _IconExport = _interopRequireDefault(require("../../svg/IconExport"));
var _IconFile = _interopRequireDefault(require("../../svg/IconFile"));
var _IconFolder = _interopRequireDefault(require("../../svg/IconFolder"));
var _IconFullScreen = _interopRequireDefault(require("../../svg/IconFullScreen"));
var _IconGraphReport = _interopRequireDefault(require("../../svg/IconGraphReport"));
var _IconHelp = _interopRequireDefault(require("../../svg/IconHelp"));
var _IconHistory = _interopRequireDefault(require("../../svg/IconHistory"));
var _IconImport = _interopRequireDefault(require("../../svg/IconImport"));
var _IconIndex = _interopRequireDefault(require("../../svg/IconIndex"));
var _IconLayers = _interopRequireDefault(require("../../svg/IconLayers"));
var _IconLibrary = _interopRequireDefault(require("../../svg/IconLibrary"));
var _IconList = _interopRequireDefault(require("../../svg/IconList"));
var _IconLocations = _interopRequireDefault(require("../../svg/IconLocations"));
var _IconMenu = _interopRequireDefault(require("../../svg/IconMenu"));
var _IconMenuHorizontal = _interopRequireDefault(require("../../svg/IconMenuHorizontal"));
var _IconModule = _interopRequireDefault(require("../../svg/IconModule"));
var _IconMyLocation = _interopRequireDefault(require("../../svg/IconMyLocation"));
var _IconNursery = _interopRequireDefault(require("../../svg/IconNursery"));
var _IconParchment = _interopRequireDefault(require("../../svg/IconParchment"));
var _IconRedo = _interopRequireDefault(require("../../svg/IconRedo"));
var _IconRestorationSite = _interopRequireDefault(require("../../svg/IconRestorationSite"));
var _IconSeedling = _interopRequireDefault(require("../../svg/IconSeedling"));
var _IconSettings = _interopRequireDefault(require("../../svg/IconSettings"));
var _IconSlice = _interopRequireDefault(require("../../svg/IconSlice"));
var _IconSubmit = _interopRequireDefault(require("../../svg/IconSubmit"));
var _IconSubtract = _interopRequireDefault(require("../../svg/IconSubtract"));
var _IconSynced = _interopRequireDefault(require("../../svg/IconSynced"));
var _IconTrashCan = _interopRequireDefault(require("../../svg/IconTrashCan"));
var _IconTreasureMap = _interopRequireDefault(require("../../svg/IconTreasureMap"));
var _IconUndo = _interopRequireDefault(require("../../svg/IconUndo"));
var _IconVariable = _interopRequireDefault(require("../../svg/IconVariable"));
var _Info = _interopRequireDefault(require("../../svg/Info"));
var _Key = _interopRequireDefault(require("../../svg/Key"));
var _Leaf = _interopRequireDefault(require("../../svg/Leaf"));
var _Lock = _interopRequireDefault(require("../../svg/Lock"));
var _MenuVertical = _interopRequireDefault(require("../../svg/MenuVertical"));
var _BlobbyIconHeartMonitor = _interopRequireDefault(require("../../svg/BlobbyIconHeartMonitor"));
var _IconHeartMonitor = _interopRequireDefault(require("../../svg/IconHeartMonitor"));
var _IconMail = _interopRequireDefault(require("../../svg/IconMail"));
var _IconNote = _interopRequireDefault(require("../../svg/IconNote"));
var _Notification = _interopRequireDefault(require("../../svg/Notification"));
var _BlobbyIconOrganization = _interopRequireDefault(require("../../svg/BlobbyIconOrganization"));
var _IconOrg = _interopRequireDefault(require("../../svg/IconOrg"));
var _BlobbyIconPeople = _interopRequireDefault(require("../../svg/BlobbyIconPeople"));
var _IconManager = _interopRequireDefault(require("../../svg/IconManager"));
var _Person = _interopRequireDefault(require("../../svg/Person"));
var _Plus = _interopRequireDefault(require("../../svg/Plus"));
var _RestorationSite = _interopRequireDefault(require("../../svg/RestorationSite"));
var _Search = _interopRequireDefault(require("../../svg/Search"));
var _IconSeedBank = _interopRequireDefault(require("../../svg/IconSeedBank"));
var _Seeds = _interopRequireDefault(require("../../svg/Seeds"));
var _Sparkles = _interopRequireDefault(require("../../svg/Sparkles"));
var _Species = _interopRequireDefault(require("../../svg/Species"));
var _Species2 = _interopRequireDefault(require("../../svg/Species2"));
var _Spinner = _interopRequireDefault(require("../../svg/Spinner"));
var _Success = _interopRequireDefault(require("../../svg/Success"));
var _SuccessFilled = _interopRequireDefault(require("../../svg/SuccessFilled"));
var _Touchscreen = _interopRequireDefault(require("../../svg/Touchscreen"));
var _UploadCloud = _interopRequireDefault(require("../../svg/UploadCloud"));
var _Warning = _interopRequireDefault(require("../../svg/Warning"));
var _IconWifi = _interopRequireDefault(require("../../svg/IconWifi"));
var _IconMarker = _interopRequireDefault(require("../../svg/IconMarker"));
var _WelcomeClipboard = _interopRequireDefault(require("../../svg/WelcomeClipboard"));
const icons = {
  blobbyGrayIconImage: _BlobbyGrayIconImage.default,
  blobbyGrayIconImport: _BlobbyGrayIconImport.default,
  blobbyGrayIconUploadToTheCloud: _BlobbyGrayIconUploadToTheCloud.default,
  blobbyIconCloudChecked: _BlobbyIconCloudChecked.default,
  blobbyIconExportOrUploadPhoto: _BlobbyIconExportOrUploadPhoto.default,
  blobbyIconFolder: _BlobbyIconFolder.default,
  blobbyIconGraphReport: _BlobbyIconGraphReport.default,
  blobbyIconHappy: _BlobbyIconHappy.default,
  blobbyIconLeaf: _BlobbyIconLeaf.default,
  blobbyIconLibrary: _BlobbyIconLibrary.default,
  blobbyIconNursery: _BlobbyIconNursery.default,
  blobbyIconParchment: _BlobbyIconParchment.default,
  blobbyIconSeedBank: _BlobbyIconSeedBank.default,
  blobbyIconSeedling: _BlobbyIconSeedling.default,
  blobbyIconSeeds: _BlobbyIconSeeds.default,
  blobbyIconSite: _BlobbyIconSite.default,
  blobbyIconSparkles: _BlobbyIconSparkles.default,
  blobbyIconWrench: _BlobbyIconWrench.default,
  bug: _Bug.default,
  calendar: _Calendar.default,
  cancel: _IconCancel.default,
  caretDown: _CaretDown.default,
  caretLeft: _CaretLeft.default,
  caretRight: _CaretRight.default,
  caretUp: _CaretUp.default,
  chargingBattery: _IconChargingBattery.default,
  checkmark: _IconCheckmark.default,
  chevronDown: _ChevronDown.default,
  chevronUp: _ChevronUp.default,
  close: _Close.default,
  critical: _Critical.default,
  dashboard: _IconDashboard.default,
  edit: _Edit.default,
  error: _Error.default,
  filter: _Filter.default,
  folder: _Folder.default,
  futures: _IconFutures.default,
  help: _Help.default,
  home: _Home.default,
  iconAdd: _IconAdd.default,
  iconArrowRight: _IconArrowRight.default,
  iconBusinessNetwork: _IconBusinessNetwork.default,
  iconCoinInHand: _IconCoinInHand.default,
  iconColumns: _IconColumns.default,
  iconComment: _IconComment.default,
  iconDataMigration: _IconDataMigration.default,
  iconEdit: _IconEdit.default,
  iconExport: _IconExport.default,
  iconFile: _IconFile.default,
  iconFolder: _IconFolder.default,
  iconFullScreen: _IconFullScreen.default,
  iconGraphReport: _IconGraphReport.default,
  iconHelp: _IconHelp.default,
  iconHistory: _IconHistory.default,
  iconImport: _IconImport.default,
  iconIndex: _IconIndex.default,
  iconLayers: _IconLayers.default,
  iconLibrary: _IconLibrary.default,
  iconList: _IconList.default,
  iconLocations: _IconLocations.default,
  iconMarker: _IconMarker.default,
  iconMenu: _IconMenu.default,
  iconMenuHorizontal: _IconMenuHorizontal.default,
  iconModule: _IconModule.default,
  iconMyLocation: _IconMyLocation.default,
  iconNursery: _IconNursery.default,
  iconParchment: _IconParchment.default,
  iconRedo: _IconRedo.default,
  iconRestorationSite: _IconRestorationSite.default,
  iconSeedling: _IconSeedling.default,
  iconSettings: _IconSettings.default,
  iconSlice: _IconSlice.default,
  iconSubmit: _IconSubmit.default,
  iconSubtract: _IconSubtract.default,
  iconSynced: _IconSynced.default,
  iconTrashCan: _IconTrashCan.default,
  iconTreasureMap: _IconTreasureMap.default,
  iconUndo: _IconUndo.default,
  iconVariable: _IconVariable.default,
  info: _Info.default,
  key: _Key.default,
  leaf: _Leaf.default,
  lock: _Lock.default,
  mail: _IconMail.default,
  menuVertical: _MenuVertical.default,
  monitoring: _BlobbyIconHeartMonitor.default,
  monitoringNav: _IconHeartMonitor.default,
  newOrganization: _WelcomeClipboard.default,
  note: _IconNote.default,
  notification: _Notification.default,
  organization: _BlobbyIconOrganization.default,
  organizationNav: _IconOrg.default,
  people: _BlobbyIconPeople.default,
  peopleNav: _IconManager.default,
  person: _Person.default,
  plus: _Plus.default,
  restorationSite: _RestorationSite.default,
  search: _Search.default,
  seedbank: _BlobbyIconSeedBank.default,
  seedbankNav: _IconSeedBank.default,
  seeds: _Seeds.default,
  sparkles: _Sparkles.default,
  species: _Species.default,
  species2: _Species2.default,
  spinner: _Spinner.default,
  success: _Success.default,
  successFilled: _SuccessFilled.default,
  touchscreen: _Touchscreen.default,
  uploadCloud: _UploadCloud.default,
  warning: _Warning.default,
  wifi: _IconWifi.default
};
var _default = exports.default = icons;